import { fileManagerRestrictionLocale } from "../../widget/file-manager/locale/en_US.js";
import { calendarLocale } from "../calendar/locale/en_US.js";
import { datePickerLocale } from "../date-picker/locale/en_US.js";
import { emptyLocale } from "../empty/locale/en_US.js";
import { paginationLocale } from "../pagination/locale/en_US.js";
import { tagSelectorLocale } from "../tag-selector/locale/en_US.js";
const locale = {
  locale: "en-US",
  global: {
    okText: "OK",
    cancelText: "Cancel"
  },
  tagSelector: tagSelectorLocale,
  empty: emptyLocale,
  pagination: paginationLocale,
  calendar: calendarLocale,
  datePicker: datePickerLocale,
  useFileManager: fileManagerRestrictionLocale
};
export {
  locale as default
};
//# sourceMappingURL=en_US.js.map
